const BACK_MAP: Record<string, string> = {
  "home": "root",
  "patients": "root",
  "patients_assignments": "patients",
  "patients_patient-detail": "patients",
  "patients_patient-detail_patient-info": "patients_patient-detail",
  "patients_patient-detail_patient-info_patient-info-view": "patients_patient-detail_patient-info",
  "patients_patient-detail_patient-info_patient-info-edit": "patients_patient-detail_patient-info",
  "patients_patient-detail_subscription": "patients_patient-detail",
  "patients_patient-detail_clinical-documentation": "patients_patient-detail",
  "patients_patient-detail_clinical-documentation_clinical-notes": "patients_patient-detail_clinical-documentation",
  "patients_patient-detail_clinical-documentation_view": "patients_patient-detail_clinical-documentation",
  "patients_patient-detail_clinical-documentation_register": "patients_patient-detail_clinical-documentation",
  "patients_patient-detail_appointments": "patients_patient-detail",
  "patients_patient-detail_forms": "patients_patient-detail",
  "patients_patient-detail_forms_answers": "patients_patient-detail_forms",
  "patients_patient-detail_legals": "patients_patient-detail",
  "chat": "root",
  "chat_connected": "chat",
  "chat_assignments": "chat",
  "chat_professional": "chat",
  "chat_customer": "chat",
  "chat_customer_activityCenter": "chat_customer",
  "chat_customer_breaks": "chat_customer",
  "chat_customer_breaks_registerBreak": "chat_customer_breaks",
  "chat_customer_clinicalHistory": "chat_customer",
  "chat_customer_clinicalHistory_sessions": "chat_customer_clinicalHistory",
  "chat_customer_clinicalHistory_sessions_view": "chat_customer_clinicalHistory_sessions",
  "chat_customer_clinicalHistory_sessions_edit": "chat_customer_clinicalHistory_sessions",
  "chat_customer_clinicalHistory_sessions_register": "chat_customer_clinicalHistory_sessions",
  "chat_customer_clinicalHistory_notes": "chat_customer_clinicalHistory",
  "chat_customer_legalAgreements": "chat_customer",
  "chat_customer_legalAgreements_view": "chat_customer_legalAgreements",
  "chat_customer_subscription": "chat_customer",
  "chat_customer_subscription_plan": "chat_customer_subscription",
  "chat_customer_subscription_sessions": "chat_customer_subscription",
  "chat_customer_subscription_sessions_refound": "chat_customer_subscription_sessions",
  "chat_customer_subscription_sessions_register": "chat_customer_subscription_sessions",
  "chat_customer_subscription_discharge": "chat_customer_subscription",
  "chat_customer_events": "chat_customer",
  "chat_customer_customer_appointments": "chat_customer",
  "chat_customer_customer_appointments_register": "chat_customer_customer_appointments",
  "chat_customer_customer_appointments_register_couple": "chat_customer_customer_appointments_register",
  "chat_customer_customer_appointments_view": "chat_customer_customer_appointments",
  "chat_customer_customer_appointments_edit": "chat_customer_customer_appointments",
  "chat_customer_customer_appointments_edit_couple": "chat_customer_customer_appointments_edit",
  "chat_customer_patientDetail": "chat_customer",
  "chat_customer_for": "chat_customer",
  "chat_customer_for_anwswers": "chat_customer_for",
  "chat_customer_for_send": "chat_customer_for",
  "calendars": "root",
  "calendars_config": "calendars",
  "calendars_config_schedule": "calendars_config",
  "calendars_config_advicePolicy": "calendars_config",
  "calendars_sync": "calendars",
  "calendars_view": "calendars",
  "activityCenter": "root",
  "settings": "root",
  "settings_subscriptions": "settings",
  "settings_subscriptions_payment": "settings_subscriptions",
  "settings_subscriptions_payment_add": "settings_subscriptions_payment",
  "settings_subscriptions_plan": "settings_subscriptions",
  "settings_subscriptions_privatePlan": "settings_subscriptions",
  "settings_subscriptions_promoCode": "settings_subscriptions",
  "settings_subscriptions_cancel": "settings_subscriptions",
  "settings_subscriptions_cancel_reason": "settings_subscriptions_cancel",
  "settings_subscriptions_sessions": "settings_subscriptions",
  "settings_loyaltyPlan": "settings",
  "settings_account": "settings",
  "settings_account_username": "settings_account",
  "settings_account_password": "settings_account",
  "settings_account_email": "settings_account",
  "settings_account_description": "settings_account",
  "settings_account_iban": "settings_account",
  "settings_account_delete": "settings_account",
  "settings_account_delete_reason": "settings_account_delete",
  "settings_myPreferences": "settings",
  "settings_myPreferences_schedule": "settings_myPreferences",
  "settings_myPreferences_areas": "settings_myPreferences",
  "settings_myPreferences_patients": "settings_myPreferences",
  "settings_myPreferences_trial": "settings_myPreferences",
  "settings_myPreferences_therapeutic-approaches": "settings_myPreferences",
  "settings_myPreferences_educations": "settings_myPreferences",
  "settings_myPreferences_additional-languages": "settings_myPreferences",
  "settings_myPreferences_price-per-session": "settings_myPreferences",
  "settings_myPreferences_timeZone": "settings_myPreferences",
  "settings_help": "settings",
  "settings_help_helpView": "settings_help",
  "settings_invoices": "settings",
  "settings_invoices_invoices_detail": "settings_invoices",
  "settings_payments": "settings",
  "settings_payments_payments_detail": "settings_payments",
  "settings_legalAgreements": "settings",
  "settings_legalAgreements_view": "settings_legalAgreements",
  "settings_notifications": "settings",
  "settings_questionnaires": "settings",
  "settings_referral": "settings",
  "settings_privacy": "settings",
  "settings_timeZone": "settings",
  "error": "root",
  "error_404": "error",
  "error_offline": "error",
  "login": "root",
  "recoverPassword": "root",
  "resetPassword": "root",
  "guest": "root",
  "loginCode": "root",
  "refreshStripe": "root",
  "sso": "root",
  "agent": "root",
  "root": "root"
};

export default BACK_MAP;